import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import { click_navigation_options } from "../../utils/constants";

function NewsImageLogo({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);

  const [inputFields, setInputFields] = useState([
    {
      img_id: "0",
      image: "",
    },
  ]);
  const [processingIndex, setProcessingIndex] = useState(-1);
  // Local source of truth for the Show Webview toggle. Not read from `preview`
  // (the shared context is reset to editdata by the parent, which has no
  // show_webview key), so this stays reliable in edit mode.
  const [showWebview, setShowWebview] = useState("0");

  // Lottie assets (uploaded .json/.lottie files). The two resulting URLs are
  // stored server-side in button_link (Lottie URL) + description (Lottie Image).
  const [lottieUrl, setLottieUrl] = useState("");
  const [lottieImage, setLottieImage] = useState("");
  const [lottieUrlProgress, setLottieUrlProgress] = useState(0);
  const [lottieImageProgress, setLottieImageProgress] = useState(0);

  const lottieUpload = async (e, which) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const setProg = which === "url" ? setLottieUrlProgress : setLottieImageProgress;
    const setVal = which === "url" ? setLottieUrl : setLottieImage;
    try {
      const formData = new FormData();
      formData.append("files", file);
      const res = await api({
        url: `/upload/brandLottie`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) =>
          setProg(Math.round((100 * data.loaded) / data.total)),
      });
      if (res.code === 200) {
        setVal(res.data.data);
      } else {
        setProg(0);
        Toast("error", res.data?.message || "Upload failed");
      }
    } catch (error) {
      setProg(0);
      Toast("error", "Upload failed");
    }
  };

  const webviewPositions = [
    { label: "Top Left", value: "1" },
    { label: "Top Right", value: "2" },
    { label: "Middle Left", value: "3" },
    { label: "Middle Right", value: "4" },
    { label: "Bottom Left", value: "5" },
    { label: "Bottom Right", value: "6" },
  ];
  
  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
      setProcessingIndex(index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = editdata.gallery[index]?.image;
          setPreview({ ...preview, gallery: gallery });
        } else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = "";
          setPreview({ ...preview, gallery: gallery });
        }
        console.log(preview);
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { gallery } = preview;
        gallery[index] = "";
        setPreview({ ...preview, gallery: gallery });
      }
      console.log(preview);
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onSubmit" });
  const imageUrl = async (imgFile, index) => {
    try {
      const formData = new FormData();
      formData.append("files", imgFile);
      let url = await api({
        url: `/upload/brandLogo`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        setInputFields(values);
        const { gallery } = preview;
        gallery[index].image = url.data.data;
        values[index].img_id = `${index}`;
        setPreview({ ...preview, gallery: gallery });
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  const handleAdd = () => {
    if (inputFields.length < 4) {
      setInputFields([
        ...inputFields,
        {
          image: "",
        },
      ]);
      const { gallery } = preview;
      gallery.push({image:""});
    } else {
      Toast("error", "Maximum limit of 4 Images exceeded");
    }
  };
  const position = watch("position",'');
  const showLottie = watch("show_lottie");

  const handleRemove = (index) => {
    setValue(`image${index}`, "");
    const values = [...inputFields];
    values.splice(index, 1);
    if (editdata.gallery && editdata.gallery[index]) {
      editdata.gallery.splice(index, 1);
    }
    setInputFields(values);
    const { gallery } = preview;
    gallery.splice(index, 1);
    setPreview({ ...preview, gallery: gallery });
  };

  useEffect(() => {
    if (flag === "edit") {
        let gallery = JSON.parse(JSON.stringify(editdata.gallery));
        setInputFields(gallery);
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        gallery: gallery,
        position: `${editdata.position}`,
        shuffle: `${editdata.shuffle}`,
      });
    }
    else{
        setPreview({
          ...preview,
          sub_type: subtype,
          gallery: inputFields,
        });
    }
  }, [company]);

  useEffect(()=>{
    if(flag==="edit"){
      console.log(editdata);
      setValue("webviewurl",editdata.video_urls)
      setValue("webviewgif", editdata.text_in_link)
      setValue("click_nav", editdata.head_line || "")
      setValue("defaultwebpreview",`${editdata.center}`)
      setValue("position",`${editdata.position}`)
      setValue("shuffle",editdata.shuffle ? "1" : "0")
      const existingLottieUrl = editdata.button_link || "";
      const existingLottieImage = editdata.description || "";
      setValue("show_lottie", (existingLottieUrl || existingLottieImage) ? true : false)
      setLottieUrl(existingLottieUrl)
      setLottieImage(existingLottieImage)
      setShowWebview(editdata.video_urls ? "1" : "0")
      setPreview({...preview,show_webview:editdata.video_urls ? "1" : "0",position:editdata.position,shuffle:editdata.shuffle ? "1" : "0" })
    }
  },[])

  const onSubmit = async (data) => {
    const isWebview = showWebview === "1";
    if(inputFields.length < 1) {
      Toast("error", "Please add atleast one image");
      return;
    }
    if (data.show_lottie && !lottieImage) {
      Toast("error", "Please upload the Lottie Image file");
      return;
    }
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        clickurl: data.clickurl,
        position:data.position,
        rotation:isWebview ? false: (data.shuffle || inputFields.length > 1 ? true : false),
        gallery : isWebview ? [inputFields[0]] : inputFields,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        video_urls: isWebview ? data.webviewurl : "",
        text_in_link:isWebview ? data.webviewgif : "",
        center:isWebview ? data.defaultwebpreview : 0,
        lottie_url: data.show_lottie ? lottieUrl : "",
        lottie_image: data.show_lottie ? lottieImage : "",
        click_nav: data.click_nav || "",
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/brandad/news-logo`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_name: creative_name,
        creative_id: editdata.creative_id,
        clickurl: data.clickurl,
        position:data.position || editdata.position,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        rotation: (data.shuffle == '1' || (!isWebview && inputFields.length > 1)) || false,
        gallery : isWebview ? [inputFields[0]] : inputFields,
        video_urls: isWebview ? data.webviewurl || editdata.video_urls : "",
        text_in_link: isWebview ? data.webviewgif || editdata.text_in_link : "",
        center:isWebview ? data.defaultwebpreview : 0,
        lottie_url: data.show_lottie ? lottieUrl : "",
        lottie_image: data.show_lottie ? lottieImage : "",
        click_nav: data.click_nav || "",
      };
      try {
        let res = await api({
          url: `/creatives/brandad/edit-news-logo`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
            <div className="form-check my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="showWebview"
            checked={showWebview === "1"}
            onChange={(e) => {
              const val = e.target.checked ? '1' : '0';
              setShowWebview(val)
              setValue("shuffle",'0')
              setPreview({
                ...preview,
                shuffle: '0',
                show_webview: val,
              })
            }}
          />
          <label className="form-check-label" htmlFor="showWebview">
            Show Webview
          </label>
        </div>

        {showWebview === '1' && <><div className="col mb-3">
                  <label className="form-label">
                    WebView URL
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("webviewurl", {
                      required: showWebview === '1' ,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.webviewurl && (
                    <p className="text-red-600">{errors.webviewurl.message || "Please Enter a Webview Url"}</p>
                  )}
        </div>
        <div className="col mb-3">
        <label className="form-label">
          WebView GIF (Ios)
        </label>
        <input
          type="text"
          className="form-control"
          {...register("webviewgif", {
            required: showWebview === '1' ,
            pattern: {
              value:
                /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*)\.gif))/,
              message: "Enter a Valid URL",
            },
          })}
        />
        {errors.webviewgif && (
          <p className="text-red-600">{errors.webviewgif.message || "Please Enter a Webview GIF"}</p>
        )}
</div></>}
            <div>
                <div>
                  {inputFields?.map((inputField, index) => (
                    <>
                      <label className="form-label" key={`label${index}`}>
                        Image {index + 1}
                      </label>
                      <br />
                      <span className="text-secondary small">
  Allowed dimensions: 240×180, 195×150, 330×440, 100×130 px
</span>
                      <div className="input-group mb-3" key={`img${index}`}>
                        <input
                          className="form-control "
                          type="file"
                          id="formFile"
                          name="files"
                          {...register(`image${index}`, {
                            required:
                              inputFields[index].image !== "" ? false : true,
                            onChange: (e) => imageChange(e, index),
                          })}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleRemove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      {errors[`image${index}`] && (
                        <p className="text-red-600">Image is mandatory</p>
                      )}
                      {processingIndex === index &&
                      progress > 0 &&
                      progress < 100 ? (
                        <SlProgressBar value={progress}>
                          {progress}%
                        </SlProgressBar>
                      ) : inputFields[index].image !== "" ? (
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-success">✓</span>
                          <span>{`${inputField.image}`}</span>
                        </div>
                      ) : (
                        flag === "edit" && <span>{`${inputField.image}`}</span>
                      )}
                      <br></br>
                    </>
                  ))}
                </div>
              {showWebview === '0' &&  <div className="flex justify-end">
                  <button
                    type="button"
                    name="add"
                    className="btn btn-primary"
                    onClick={() => handleAdd()}
                  >
                    Add
                  </button>
                </div>}
              </div>

              {/* Show Lottie — upload two Lottie assets (.json / .lottie) to the
                  brand-ads bucket. URLs are stored in button_link + description.
                  Independent of Webview. */}
              <div className="form-check my-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="showLottie"
                  {...register("show_lottie")}
                />
                <label className="form-check-label" htmlFor="showLottie">
                  Show Lottie
                </label>
              </div>
              {showLottie && (
                <>
                <div className="col mb-3">
                    <label className="form-label">Lottie Image (.json / .lottie)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".json,.lottie,application/json"
                      onChange={(e) => lottieUpload(e, "image")}
                    />
                    {lottieImageProgress > 0 && lottieImageProgress < 100 ? (
                      <SlProgressBar value={lottieImageProgress}>
                        {lottieImageProgress}%
                      </SlProgressBar>
                    ) : lottieImage ? (
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-success">✓</span>
                        <span className="text-break">{lottieImage}</span>
                      </div>
                    ) : null}
                  </div>
                  <div className="col mb-3">
                    <label className="form-label">Lottie URL (.json / .lottie)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".json,.lottie,application/json"
                      onChange={(e) => lottieUpload(e, "url")}
                    />
                    {lottieUrlProgress > 0 && lottieUrlProgress < 100 ? (
                      <SlProgressBar value={lottieUrlProgress}>
                        {lottieUrlProgress}%
                      </SlProgressBar>
                    ) : lottieUrl ? (
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-success">✓</span>
                        <span className="text-break">{lottieUrl}</span>
                      </div>
                    ) : null}
                  </div>                  
                </>
              )}

              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">
                    Click URL / Mobile Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url}
                    name="clickurl"
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
              </div>

               <div className="col">
                  <label className="form-label">
                    Section Navigation
                  </label>
                  // A dropdown select option for section navigation.
                  <select
                    className="form-select"
                    {...register("click_nav", {
                      required: false,
                    })}
                  >
                    <option value="">Select Section Navigation</option>
                    {click_navigation_options.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col">
                  {errors.click_nav && (
                    <p className="text-red-600">{errors.click_nav.message}</p>
                  )}
                </div>


        <div>
          <h6>Logo Position</h6>

          {(showWebview === '1' ? webviewPositions : [
            { label: "Top Left", value: "1" },
            { label: "Top Right", value: "2" },
          ]).map((pos) => (
            <div className="form-check form-check-inline" key={pos.value}>
              <input
                className="form-check-input"
                type="radio"
                id={`position-${pos.value}`}
                value={pos.value}
                {...register("position", { required: true })}
                checked={preview.position == (pos.value)}
                onChange={() =>{
                  setValue("position",(pos.value))
                  setPreview({ ...preview, position: (pos.value) })
                }}
              />
              <label className="form-check-label" htmlFor={`position-${pos.value}`}>
                {pos.label}
              </label>
            </div>
          ))}
          {errors?.position &&  !preview?.position && (
            <p className="text-red-600">Please select a position</p>
          )}
          <div>
          {showWebview === '1' ? (<>
          <h6>Select Action</h6>
            <div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="noaction"
    value="0"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="noaction">
    No Action
  </label>
</div><div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="defaultwebpreview"
    value="1"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="defaultwebpreview">
    Default WebPreview
  </label>
</div>

<div className="form-check form-check-inline">
  <input
    className="form-check-input"
    type="radio"
    id="redirect"
    value="2"
    {...register("defaultwebpreview", { required: true })}
    onChange={(e) =>
      setPreview({ ...preview, defaultwebpreview: e.target.value })
    }
  />
  <label className="form-check-label" htmlFor="redirect">
    Redirect
  </label>
</div></>
) : (<div className="form-check">
                <input
                  className="form-check-input"
                  id="Rotation"
                  type="checkbox"
                  checked={preview.shuffle == '1' ? true : false}
                  {...register("shuffle", { required: false })}
                  onChange={(e) => {console.log(e.target.checked); setPreview({...preview, shuffle: e.target.checked ? '1' : '0'})}}
                />
                <label className="form-check-label" htmlFor="Rotation">
                  Rotation
                </label>
              </div>) }</div>
        </div>
              <div className="my-3 text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress > 0 && progress < 100 ? true : false}
                >
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default NewsImageLogo;
